import { Component, OnInit, OnDestroy } from '@angular/core';

// ionic
import { ModalController } from '@ionic/angular';

// other libraries
import { TranslateService } from "@ngx-translate/core";

// rxjs
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

// providers
import { EventService } from "../../services/event.service";
import { UserService } from "../../services/user.service";
import { OverlayService } from "../../services/overlay.service";
import { PlatformService } from "../../services/platform.service";

// models
import { Event } from "../../models/event";
import { EventSetting } from "../../models/event-setting";
import { User } from "../../models/user";


@Component({
    selector: 'app-imprint-detail',
    templateUrl: './event-imprint.component.html',
    styleUrls: ['./event-imprint.component.scss'],
})
export class EventImprintComponent implements OnInit, OnDestroy {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * current event
     *
     * @type {User}
     */
    public user: User;

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;

    /**
     * event
     *
     * @type {Event}
     */
    public event: Event;


    public loading: boolean = true;

    /**
     * profile of attendee which is presented
     *
     * @type {Participant}
     */
    public eventSetting;

    /**
     * constructor
     *
     * @param pushPageService
     * @param userProvider
     * @param appEvents
     */
    constructor(
        public eventService: EventService,
        public translate: TranslateService,
        public userService: UserService,
        public overlayService: OverlayService,
        public plt: PlatformService,
        public modalController: ModalController
    ) {
        // user language
        this.userLang = this.translate.currentLang;
    }

    ngOnInit() {
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        )
            .subscribe((user: User) => {
                this.user = user;
            });

        this.eventService.getCurrentEvent().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe((event) => {
            this.event = event;
            // load imprint from backend
            this.eventService.getSetting(this.event.id).subscribe((eventSetting: EventSetting) => {
                this.eventSetting = new EventSetting(eventSetting)
                this.loading = false;
            }, (error) => {
                this.loading = false
            });
        });
    }

    close() {
        this.modalController.dismiss({ action: 'close' });
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.overlayService.closeModals();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }


}
